import CanPerform from './CanPerform';

export default CanPerform;
